module.exports = __webpack_public_path__ + "img/kjrc_Select.556091d.png";